/*
https://splidejs.com/guides/getting-started/
*/

import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener( 'DOMContentLoaded', function() {

    if (('.carousel-slider').length) {
        const carouselSlider = document.querySelector('.carousel-slider');
        if( carouselSlider ) {
            var splideCarousel = new Splide( '.carousel-slider' , {
                type        : 'loop',
                drag        : 'free',
                focus       : 'center',
                direction   : 'rtl',
                perPage     : 3,
                autoWidth   : true,
                gap         : '6em',
                autoStart   : true,
                autoScroll  : {
                    speed: -1,
                },
                // speed       : 800,
                arrows      : false,
                pagination  : false,
                breakpoints : {
                    768: {
                        perPage: 2,
                    },
                    960: {
                        perPage: 2,
                    },
                    1100: {
                        perPage: 3,
                    },
                }
            });
            splideCarousel.mount( { AutoScroll } );
        }
    }
});